import React from "react"

import { ProjectAttachmentsOverlay } from "./ProjectAttachmentsOverlay"
import { useProjectAttachmentsOverlayModel } from "./hooks/useProjectAttachmentsOverlayModel"
import { useSharedProjectAttachmentsOverlayModel } from "./hooks/useSharedProjectAttachmentsOverlayModel"

export interface ProjectAttachmentsOverlayPayload {
  projectID: string
  isShareID?: boolean
}

export interface ProjectAttachmentsOverlayConnectorProps {
  payload: ProjectAttachmentsOverlayPayload
}

export const ProjectAttachmentsOverlayConnector = React.memo(
  (props: ProjectAttachmentsOverlayConnectorProps) => {
    const { isShareID } = props.payload

    if (isShareID) {
      return <SharedProjectAttachmentsOverlayConnector {...props} />
    }
    return <DefaultProjectAttachmentsOverlayConnector {...props} />
  }
)

export const SharedProjectAttachmentsOverlayConnector = React.memo(
  (props: ProjectAttachmentsOverlayConnectorProps) => {
    return (
      <ProjectAttachmentsOverlay
        {...useSharedProjectAttachmentsOverlayModel(props)}
      />
    )
  }
)

export const DefaultProjectAttachmentsOverlayConnector = React.memo(
  (props: ProjectAttachmentsOverlayConnectorProps) => {
    return (
      <ProjectAttachmentsOverlay
        {...useProjectAttachmentsOverlayModel(props)}
      />
    )
  }
)

declare module "shared/context/overlay/registry" {
  interface OverlayPayloadRegistry {
    PROJECT_ATTACHMENTS_OVERLAY: ProjectAttachmentsOverlayPayload
  }
}
